<template>
    <div class="mine-module">
        <div class="HomeTitle">
            <div class="head">
                <div class="openhead">
                    <img class="headimg" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/head.png" alt="">
                </div>
                <div class="info">
                    <div class="infoname">
                        <div></div>
                        <div class="post" :style="8">11</div>
                    </div>
                    <div class="infostore"></div>
                </div>
            </div>
        </div>
        <div class="menulist">
            <div>
                <div class="menuitem">
                    <img class="icon" src="" alt="">
                    <div class="menutit"></div>
                    <img class="arrow" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/r-arrow.png"
                        alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    name: "mine",
    data() {
        return {};
    },
    created() {
    },
    methods: {

    },
};
</script>
<style lang="less" scoped>
.HomeTitle {
    width: 750px;
    /* height: 431px; */
    background: linear-gradient(90deg, #1db2e4 0%, #4ae0d9 100%);
    color: #fff;
    box-sizing: border-box;
    padding-bottom: 60px;
    overflow-x: hidden;
    font-size: 34px;
}
.head {
    margin-left: 30px;
    margin-top: 49px;
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
}
.openhead {
    width: 130px;
    height: 130px;
}
.head .headimg {
    width: 130px;
    height: 130px;
    display: block;
    overflow: hidden;
    border-radius: 50%;
}
.info {
    flex: 1;
    height: 130px;
    padding-left: 30px;
    box-sizing: border-box;
}
.infoname {
    height: 50%;
    font-weight: bold;
    font-size: 34px;
    line-height: 50%;
    display: flex;
    align-items: center;
}
.infoname view {
    height: 50%;
}
.infoname .post {
    font-size: 26px;
    margin-left: 20px;
    color: #d5f3f8;
}
.infostore {
    height: 50%;
    display: flex;
    align-items: center;
    font-size: 26px;
    color: #d5f3f8;
}

/* ------- */
.menulist {
    width: 100%;
    padding: 0px 30px 50px;
    box-sizing: border-box;
}
.menuitem {
    width: 100%;
    height: 127px;
    border-bottom: 1px solid #f3f3f3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.icon {
    width: 50px;
    height: 50px;
    margin-right: 20px;
}
.arrow {
    width: 16px;
    height: 27px;
}
.menutit {
    flex: 1;
    font-size: 30px;
    color: #35434c;
}
</style>